import React from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { Link } from 'react-router-dom';
import AbsoluteValue from '../../common/AbsoluteValue';
import PercentageValue from '../../common/PercentageValue';
import Tooltip from '../../common/Tooltip';
import { avgFooter, convertSumFooter } from '../../common/Datagrid/Footers';
import CountryFlag from '../../common/CountryFlag';
import ConfirmClick from '../../common/ConfirmClick';
import FilterSummary from '../mailingLists/FilterSummary';
import FilterContents from '../mailingLists/FilterContents';

export const catalogMailingListsSettings = {
	settingsForTable
};


function settingsForTable(deleteCall){
	let columns = [
	 {
		   id: 'entity_type',
		   Header: 'Base Entity',
		   accessor: 'entity_type'
	   },      
	
	   {
		   id: 'user_filter',
		   Header: 'Filter',
		   accessor: 'user_filter',
		   Cell: props => <FilterSummary filter={props.value} />
	   },      
	   {
			  id: 'user_filter_contents',
			  Header: 'User Filter',
			  accessor: 'user_filter',
			  Cell: props => <FilterContents filter={props.value} />
		  },      

	   {
		   id: 'actions',
		   className: 'milestone-actions',
		   headerClassName: 'no-sort milestone-actions',
		   Header: 'Actions',
		   sortable: false,
		   // <a onClick={()=>setCurrentMilestone(props.original, 'showAddChannelModal')} className="btn add-to-filter"><i class="fas fa-plus"></i></a>
		   Cell: props => <div className="">
		    <Link to={`/user/catalog-report/recipients/${props.original.id}`}>Recipients</Link>
			<Link to={`/user/catalog-report/${props.original.id}`}>Edit</Link>
			<ConfirmClick confirmAction={()=>deleteCall(props.original.id)} confirmClass="btn add-to-filter" confirmLabel={<i className="fas fa-trash-alt"></i>} confirmPrompt="Delete Mailing List?" title="Delete" extraClass="dialog-modal"></ConfirmClick>
		   </div>
	   }
	   
	];
	return columns;
}
